import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Typography} from "@material-ui/core";
import {IDataPartner} from "../../../types";
import "./styles.css";


interface IProps {
    partnerData: IDataPartner
}

interface Istate {
    resetC0: boolean
    resetC1: boolean
    resetC2: boolean
    resetC3: boolean
}

interface IRowChart {
    name: string
    value: number
}


class Hectareas extends React.Component<IProps, Istate> {

    state:Istate = {
        resetC0: true,
        resetC1: true,
        resetC2: true,
        resetC3: true,
    }

    componentDidMount() {
        this.setState({resetC3: true})
        setTimeout(() => this.setState({resetC3: false}), 250)


        setTimeout(() => this.setState({resetC2: true}), 250)
        setTimeout(() => this.setState({resetC2: false}), 500)


        setTimeout(() => this.setState({resetC1: true}), 500)
        setTimeout(() => this.setState({resetC1: false}), 750)


        setTimeout(() => this.setState({resetC0: true}), 750)
        setTimeout(() => this.setState({resetC0: false}), 1000)
    }


    getTotalSurface = (): number => {
        let surface = 0
        if (!this.props.partnerData.hasOwnProperty("plots")) return surface

        for (let user of Object.keys(this.props.partnerData.plots)) {
            for (let plot of this.props.partnerData.plots[user]) {
                if (plot["eliminada"] !== 0) continue
                surface += plot["superficie"] as number
            }
        }
        return Math.round(surface/1000)/10
    }

    createDataChart = (): IRowChart[] => {
        let basico = {name: "Básico", value: 0} as IRowChart
        let avanzado = {name: "Avanzado", value: 0} as IRowChart
        let profesional = {name: "Profesional", value: 0} as IRowChart
        let otro = {name: "Otro", value: 0} as IRowChart

        let users_basico = [] as string[]
        let users_avanzado = [] as string[]
        let users_profesional = [] as string[]
        let users_otro = [] as string[]

        if (!this.props.partnerData.hasOwnProperty("plots")) return [basico, avanzado, profesional, otro]
        if (!this.props.partnerData.hasOwnProperty("users")) return [basico, avanzado, profesional, otro]

        for (let user of this.props.partnerData.users) {
            if (user.level === 1) {
                users_basico.push(user.nombre as string)
            } else if (user.level === 2) {
                users_avanzado.push(user.nombre as string)
            } else if (user.level === 3) {
                users_profesional.push(user.nombre as string)
            } else {
                users_otro.push(user.nombre as string)
            }
        }

        for (let user of users_basico) {
            for (let plot of this.props.partnerData.plots[user]) {
                if (plot["eliminada"] !== 0) continue
                basico.value += plot["superficie"] as number
            }
        }

        for (let user of users_avanzado) {
            for (let plot of this.props.partnerData.plots[user]) {
                if (plot["eliminada"] !== 0) continue
                avanzado.value += plot["superficie"] as number
            }
        }

        for (let user of users_profesional) {
            for (let plot of this.props.partnerData.plots[user]) {
                if (plot["eliminada"] !== 0) continue
                profesional.value += plot["superficie"] as number
            }
        }

        for (let user of users_otro) {
            for (let plot of this.props.partnerData.plots[user]) {
                if (plot["eliminada"] !== 0) continue
                otro.value += plot["superficie"] as number
            }
        }

        return [basico, avanzado, profesional, otro]
    }


    render() {

        const dataChart = this.createDataChart()

        const colors = ['rgba(255,119,119,0.9)', 'rgba(105,75,219,0.9)', 'rgba(43,235,200,0.9)', 'rgba(246,217,71,0.9)'];
        const totalSurface = this.getTotalSurface()

        let sizes = [] as number[]
        let surfaces = [] as number[]
        let surfacePercentages = [] as number[]

        let maxsize = 90
        let minSize = 20
        for (let element of dataChart) {
            sizes.push(minSize + Math.sqrt(element.value/(totalSurface*10000)) * (maxsize - minSize))
            surfaces.push(Math.round(element.value/100)/100)
            surfacePercentages.push(Math.round(element.value/(totalSurface))/100)
        }

        let BaseH = (window.innerHeight - 72 - 80 - 20)/2 - 120

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: '100%',
                    height: '100%',
                    backgroundColor: "white",
                    borderRadius: 20,
                    overflow: "auto"
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        height: 30,
                        width: '100%',
                        marginTop: 20
                    }}
                >
                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            marginLeft: 40,
                        }}
                    >
                        Hectáreas por categoría de usuario
                    </Typography>

                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            marginLeft: 40,
                            color: "grey",
                            fontSize: 12
                        }}
                    >
                        Total: {totalSurface} Ha
                    </Typography>

                </div>

                <div
                    id={"basico"}
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        width: 'calc(100% - 40px)',
                        height: 'calc(100% - 100px)',
                        marginBottom: 20,
                        position: "relative"
                    }}
                >

                    <div
                        style={{
                            height: BaseH,
                            width: BaseH,
                            position: "relative"
                        }}
                    >
                        {dataChart[0].value > 0 &&
                            <div
                                className="circ0"
                                style={{
                                    position: "absolute",
                                    top: BaseH/2-BaseH*sizes[0]/200,
                                    left: BaseH*7/10-BaseH*sizes[0]/200,
                                    height: BaseH*sizes[0]/100,
                                    width: BaseH*sizes[0]/100,
                                    borderRadius: BaseH*sizes[0]/200,
                                    backgroundColor: this.state.resetC0? "white" : ""
                                }}
                            >

                            </div>
                        }

                        {dataChart[1].value > 0 &&
                            <div
                                className="circ1"
                                style={{
                                    position: "absolute",
                                    top: BaseH/4-BaseH*sizes[1]/200,
                                    left: BaseH/2-BaseH*sizes[1]/200,
                                    height: BaseH*sizes[1]/100,
                                    width: BaseH*sizes[1]/100,
                                    borderRadius: BaseH*sizes[1]/200,
                                    backgroundColor: this.state.resetC1? "white" : ""
                                }}
                            >

                            </div>
                        }

                        {dataChart[2].value > 0 &&
                            <div
                                className="circ2"
                                style={{
                                    position: "absolute",
                                    top: BaseH*3/4-BaseH*sizes[2]/200,
                                    left: BaseH*2/5-BaseH*sizes[2]/200,
                                    height: BaseH*sizes[2]/100,
                                    width: BaseH*sizes[2]/100,
                                    borderRadius: BaseH*sizes[2]/200,
                                    backgroundColor: this.state.resetC2? "white" : ""
                                }}
                            >

                            </div>
                        }

                        {dataChart[3].value > 0 &&
                            <div
                                className="circ3"
                                style={{
                                    position: "absolute",
                                    top: BaseH/4-BaseH*sizes[3]/200,
                                    left: BaseH*3/10-BaseH*sizes[3]/200,
                                    height: BaseH*sizes[3]/100,
                                    width: BaseH*sizes[3]/100,
                                    borderRadius: BaseH*sizes[3]/200,
                                    backgroundColor: this.state.resetC3? "white" : ""
                                }}
                            >

                            </div>
                        }
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            width: 160,
                            height: '100%',
                            zIndex: 100,
                            borderRadius: 25,
                            backgroundColor: 'rgba(255,255,255,0.7)',
                            position: "absolute",
                            top: 0,
                            left: BaseH*1.2,
                        }}
                    >
                        {dataChart.map((value, index) =>
                            <div
                                key={index}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    height: 50,
                                    marginLeft: 10
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        width: "100%"
                                    }}
                                    key={index}
                                >
                                    <div style={{width: 20, height: 20, borderRadius: 5, backgroundColor: colors[index]}}/>
                                    <Typography
                                        style={{
                                            marginLeft: 10,
                                            fontFamily: "Poppins",
                                            color: colors[index]
                                        }}
                                    >
                                        {value.name}
                                    </Typography>
                                </div>
                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        color: colors[index],
                                        fontSize: 14,
                                        fontWeight: "bold"
                                    }}
                                >
                                    {surfaces[index]} Ha ({surfacePercentages[index]} %)
                                </Typography>
                            </div>
                        )}

                    </div>

                </div>

            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    partnerData: state.partner.dataPartner
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Hectareas);
